import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import VuexRouterSync from 'vuex-router-sync'
import App from './App'
import JQuery from 'jquery';
import ElementUi from 'element-ui';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import i18n from './i18n'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import VueCarousel from 'vue-carousel';
import VueKatex from 'vue-katex';

window.$ = JQuery;

import '@/plugins'
import '@/validators'
import '@/directives'
import '@/locales'
import '@/components'

Vue.config.productionTip = false

import '../public/css/fonts.css';
import '../public/css/main.css';
import '../public/css/profile.css';
import '../public/css/media.css';
import '../public/css/ck-content.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

VuexRouterSync.sync(store, router)

Vue.use(VueKatex, {
  globalOptions: {
    // ... Define globally applied KaTeX options here
  }
});
Vue.use(BootstrapVue)
Vue.use(ElementUi, {locale})
Vue.use(VueCarousel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  ...App
})